"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.131 4c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3Zm-1 0c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4Zm2.782 6.116.994 5.684 1.033-5.748a5.966 5.966 0 0 0-.808-.061c-.418 0-.825.044-1.22.125ZM1.132 15.99c0-3.86 3.14-7 7-7 3.859 0 7 3.14 7 7h-1a6.007 6.007 0 0 0-3.73-5.55l.45 2.043H9.556l.667 1.03L8.79 16l-.883-.004-.884.004-1.4-2.486.668-1.03H4.994l.402-1.826a6.001 6.001 0 0 0-3.264 5.333h-1Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.131 12.375a6.195 6.195 0 0 1-6.187-6.188A6.195 6.195 0 0 1 12.13 0a6.195 6.195 0 0 1 6.188 6.188 6.195 6.195 0 0 1-6.188 6.187Zm0-11.25A5.068 5.068 0 0 0 7.07 6.188a5.068 5.068 0 0 0 5.062 5.062 5.068 5.068 0 0 0 5.063-5.063 5.068 5.068 0 0 0-5.063-5.062ZM1.82 23.999c0-5.686 4.626-10.312 10.312-10.312 5.687 0 10.313 4.626 10.313 10.312H21.32c0-3.639-2.132-6.78-5.207-8.267l.733 3.33h-1.944l1 1.546-1.88 3.39h-1.54l1.573-8.98a9.177 9.177 0 0 0-1.923-.206c-.659 0-1.3.072-1.922.205l1.573 8.98h-1.54l-1.88-3.389 1-1.545H7.417l.733-3.331c-3.075 1.486-5.206 4.629-5.206 8.267H1.819Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16.175 16.5c-4.549 0-8.25-3.701-8.25-8.25 0-4.549 3.701-8.25 8.25-8.25 4.55 0 8.25 3.701 8.25 8.25 0 4.549-3.7 8.25-8.25 8.25Zm0-15a6.758 6.758 0 0 0-6.75 6.75 6.758 6.758 0 0 0 6.75 6.75 6.758 6.758 0 0 0 6.75-6.75 6.758 6.758 0 0 0-6.75-6.75ZM2.425 31.999c0-7.582 6.168-13.75 13.75-13.75s13.75 6.168 13.75 13.75h-1.5c0-4.852-2.842-9.041-6.942-11.023l.977 4.441h-2.592l1.334 2.061-2.508 4.519h-2.053l2.097-11.974a12.24 12.24 0 0 0-2.563-.274c-.879 0-1.735.097-2.563.274l2.097 11.974h-2.053l-2.508-4.519 1.334-2.061H9.89l.978-4.441c-4.1 1.982-6.942 6.172-6.942 11.023h-1.5Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.11 12.188c0-5.687 4.627-10.313 10.313-10.313 5.687 0 10.313 4.626 10.313 10.313 0 5.686-4.626 10.312-10.313 10.312-5.686 0-10.312-4.626-10.312-10.313Zm-1.874 0c0 6.72 5.467 12.187 12.187 12.187s12.188-5.468 12.188-12.188C36.61 5.468 31.143 0 24.423 0c-6.72 0-12.187 5.468-12.187 12.188Zm12.187 15.37a20.3 20.3 0 0 1 14.45 5.987 20.302 20.302 0 0 1 5.988 14.45h-1.875c0-4.957-1.931-9.618-5.438-13.124a18.53 18.53 0 0 0-6.073-4.056l1.573 6.986h-3.564l1.835 2.769L27.035 48h-2.26l3.292-18.212a18.714 18.714 0 0 0-7.287.006L24.025 48h-2.259l-4.237-7.43 1.834-2.77H15.8l1.57-6.972c-6.747 2.783-11.51 9.428-11.51 17.167H3.986c0-11.27 9.169-20.438 20.437-20.438Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18.815 16.25c0-7.582 6.168-13.75 13.75-13.75s13.75 6.168 13.75 13.75S40.147 30 32.565 30s-13.75-6.168-13.75-13.75Zm-2.5 0c0 8.96 7.29 16.25 16.25 16.25s16.25-7.29 16.25-16.25S41.525 0 32.565 0s-16.25 7.29-16.25 16.25Zm16.25 20.493c7.277 0 14.119 2.835 19.267 7.983s7.983 11.99 7.983 19.267h-2.5c0-6.609-2.575-12.824-7.251-17.499a24.707 24.707 0 0 0-8.097-5.407l2.097 9.314h-4.752l2.447 3.692L36.047 64h-3.012l4.388-24.283a24.953 24.953 0 0 0-9.716.008L32.034 64h-3.012l-5.65-9.907 2.446-3.692h-4.752l2.093-9.297c-8.994 3.71-15.344 12.571-15.344 22.89h-2.5c0-15.027 12.225-27.25 27.25-27.25Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconAgent = function IconAgent(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Agent' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Agent"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconAgent.sizes = [16, 24, 32, 48, 64];
IconAgent.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconAgent;
exports.default = _default;